<div>
    <lib-contract-state-base title="Por favor descarga e 
        imprime tu carta compromiso de compra de acciones, 
        fírmala y subela escaneada en formato pdf o jpg" [hasSubtitle]="false" [svg]="svg" [hasDownloadIcon]="true"
        (click)="downloadFile()">
    </lib-contract-state-base>

    <div *ngIf="hasSelectedFile; else elseBlock" class="row alert alert-success" role="alert">

        <lib-pdf-svg class="col-sm-2 col-md-2"></lib-pdf-svg>

        <div class="col-sm-9 col-md-9 d-flex flex-column justify-content-center"><b>{{selectedFileName}} </b></div>
        <div class="col-sm-1 col-md-1 ">
            <p (click)="removeFile()" class="delete-selected-file mt-3">&#10060;</p>
        </div>

    </div>

    <ng-template #elseBlock>
        <div *ngIf="hasSelectedFileTypeError" class="alert alert-danger" role="alert">
            <div class="selected-file-name">{{fileTypeErrorMessage}}</div>
        </div>
        <div *ngIf="hasSelectedFileSizeError" class="alert alert-danger" role="alert">
            <div class="selected-file-name">{{fileSizeErrorMessage}}</div>
        </div>
    </ng-template>

    <lib-button-1 [buttonText]="buttonText" (buttonPressed)="onClick()">
    </lib-button-1>

    <input type="file" accept="application/pdf, image/*" #fileinput />

        <!--FOOTER-->
        <h4 class="text-warning mt-5" >
            Es indispensable adjuntar la carta firmada para concluir el proceso,<br>
            de lo contrario se cancelará la solicitud.
        </h4>
</div>